import { supabase } from "../utility/supabaseClient";
import { useState, useEffect } from "react";
import Layout from "../Layouts/LayoutWide.jsx";
import Spinner from "../components/Spinner.jsx";
import Grafana from "../components/Grafana.jsx";
import NoDevices from "../components/NoDevices.jsx";
import useSessionStore from "../stores/sessionStore";

export default function Analytics() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null)
  const [dashboard, setDashboard] = useState(null)
  const user = useSessionStore((state) => state.user);

  const getDashboards = async () => {
    const { data, error } = await supabase.from("teamdashboards").select("*").eq("team_id", user.profile.team_id);
    if (error) {
      console.error("Error fetching dashboards:", error.message); // TK
      return
    }
    setDashboard(data);
    setLoading(false);
  };

  useEffect(() => {
    if (!dashboard) {
      getDashboards();
    } else {
      setLoading(false);
    }
  }, []);

  if (loading) {
    return (
      <Layout title="Dashboard">
        <div className="h-screen">
          <Spinner />
        </div>
      </Layout>
    );
  }

  if (!dashboard || dashboard.length === 0) {
    return (
      <Layout title="Dashboard">
        <div className="h-screen py-8 text-gray-700">
          Your device is connected!
        </div>
        <div className="h-screen py-8 text-gray-500">
          {`Reload your browser and you're all set!`}
        </div>
      </Layout>
    );
  }

  return (
    <Layout title="Dashboard">
      <Grafana className="h-full w-full" dashboard={dashboard[0]} />
    </Layout>
  );
};
